import React, { Component } from 'react';
import { Layout } from './components/Layout'
import  AuthPage  from './components/AuthPage'
import { withRouter } from "react-router-dom";
import ToS from './components/ToS';
import $ from 'jquery';
 class App extends Component {
    static displayName = App.name;  
    
    constructor(props) {
        super(props);
        this.state = { name: "", picUrl: "",accNum:"" ,auth: false ,agreeToS:true, attemptToS:false};
        this.getUserInfo = this.getUserInfo.bind(this);
        this.showBusy = this.showBusy.bind(this);
        this.tosDecListener = this.tosDecListener.bind(this);
    }

    getUserInfo = async () => {
        let resp = await fetch('api/auth/checkprofile', {
            method: 'GET',
            credentials: 'same-origin'
        });

        if (resp.status === 200) {
            let jdata = await resp.json();
      
            this.setState({ name: jdata.name, picUrl: jdata.picUrl, accNum: jdata.accNum, auth: true });
            await this.setState({ agreeToS: jdata.agreeToS });
         
            if (!this.state.agreeToS) {
                
                $('#tosModal').on('hide.bs.modal', this.tosDecListener);              
                $('#tosModal').modal('show');
                this.setState({ attemptToS: true });
            }
          
        }
        else if (resp.status === 500)
        {
            const resp =
                await fetch('api/auth/signout', {
                    method: 'POST',
                    credentials: 'same-origin'

                });

            if (resp.status === 200) {

                this.setState({ auth: false })              
                //this.props.history.push("/");
                //Cant access this here so going with reload for now
                window.location.reload(false);
            }
        }
        else {
            console.dir(resp);
            this.setState({ auth: false })
        }
    }

    async componentDidMount() {        
        (async () => { this.getUserInfo() })();       
     }

    
     showBusy = (b) => {
        
         if (b) {
             $('#busyModal').modal("show");
             //console.log('showBusy:true')
         }
         else {
             $('#busyModal').modal("hide");
            // console.log('showBusy:false')
         }

     }

     tosAcc = async () => {
         console.log(this.state.accNum);
         var data = { accNum: this.state.accNum };
         const resp = await fetch('api/auth/accepttos', {
             method: 'POST',
             credentials: 'same-origin',
             body: JSON.stringify(data),
             headers: {
                 'Content-Type': 'application/json'
             }
         });
         if (resp.status === 200) {
             await this.setState({ agreeToS: true });
             console.log("Accepted");
             $('#tosModal').modal('hide');
         }
         else {

         }
         
     }
     tosDecListener = () => {
         if (!this.state.agreeToS && this.state.attemptToS) {
             window.location.replace(window.location.origin + "/home");
         }
     }
     
    render() {
        
        const authprops = this.state;
        const tosText =  <ToS /> ;
        return (
            <div>
                {!this.state.auth ? <AuthPage {...this.props} getUserInfo={this.getUserInfo}></AuthPage> :
                    <Layout {...authprops} refreshUser={this.getUserInfo} showBusy={this.showBusy}>
                    </Layout>  
                }

                <div className="modal fade" id="tosModal" tabIndex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">gstitch</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {tosText}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" onClick={this.tosAcc}>Agree</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal" >Decline</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="busyModal" tabIndex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">

                            <div className="modal-body">
                                <div className="">  <img src="/img/gstitch-spinner.svg" alt="" /> Working... </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>           
        );
     }
 
}
export default withRouter(App)